
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/revoke-bureau-consent",
      function () {
        return require("private-next-pages/revoke-bureau-consent/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/revoke-bureau-consent"])
      });
    }
  